"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rehydrateFromDottishKeyedObject = exports.convertToDottishKeyedObject = exports.glueCompatibleDottishKeyRehydrator = exports.convertToGlueCompatibleDottishKey = exports.STANDARD_GLUE_ATTRIBUTE_DOUBLE_UNDERSCORE = exports.convertToDotKey = void 0;
/** accepts an object and flattens such that each nested key becomes a top level dot access key, used for parameter store etc */
const convertToDotKey = (input) => {
    return (0, exports.convertToDottishKeyedObject)({ input, levelSeparator: '.' });
};
exports.convertToDotKey = convertToDotKey;
exports.STANDARD_GLUE_ATTRIBUTE_DOUBLE_UNDERSCORE = '__';
/** accepts an object and flattens such that each nested key becomes a top level dot-like access key using STANDARD_GLUE_ATTRIBUTE_DOUBLE_UNDERSCORE: __
 * this is the LSC adopted standard for Glue compatibility  */
const convertToGlueCompatibleDottishKey = (input) => {
    return (0, exports.convertToDottishKeyedObject)({ input, levelSeparator: exports.STANDARD_GLUE_ATTRIBUTE_DOUBLE_UNDERSCORE });
};
exports.convertToGlueCompatibleDottishKey = convertToGlueCompatibleDottishKey;
/** accepts any object and if any keys are indicated as nested by STANDARD_GLUE_ATTRIBUTE_DOUBLE_UNDERSCORE rehydrates these to nested keys */
const glueCompatibleDottishKeyRehydrator = (input) => (0, exports.rehydrateFromDottishKeyedObject)({ input, levelSeparator: exports.STANDARD_GLUE_ATTRIBUTE_DOUBLE_UNDERSCORE });
exports.glueCompatibleDottishKeyRehydrator = glueCompatibleDottishKeyRehydrator;
/**
 * Flattens object with attributes being renamed by a nested dot-like approach eg location__lat
 * Some usages (Glue) may not allow dots, so this implementation of convertToDotKey allows alternatives */
const convertToDottishKeyedObject = ({ input, levelSeparator, target = {}, currentKeyPath = [] }) => {
    const entries = Object.entries(input);
    for (let [k, v] of entries) {
        const thisKeyPath = [...currentKeyPath, k];
        if (['string', 'number', 'boolean'].includes(typeof v)) {
            const thisKey = thisKeyPath.join(levelSeparator);
            target[thisKey] = v;
        }
        else if (!!v && typeof v === 'object') {
            (0, exports.convertToDottishKeyedObject)({ input: v, levelSeparator, target, currentKeyPath: thisKeyPath });
        }
    }
    return target;
};
exports.convertToDottishKeyedObject = convertToDottishKeyedObject;
/** rehydrates original object given a levelSeparator ( eg . or __ ) and a flat object where keys have been made dottish to reflect nesting */
const rehydrateFromDottishKeyedObject = ({ input, levelSeparator }) => {
    function deepMerge(target, source) {
        for (const key of Object.keys(source)) {
            if (source[key] && typeof source[key] === 'object' &&
                !Array.isArray(source[key]) &&
                target[key] && typeof target[key] === 'object' &&
                !Array.isArray(target[key])) {
                target[key] = deepMerge(target[key], source[key]);
            }
            else {
                target[key] = source[key];
            }
        }
        return target;
    }
    return Object.entries(input).reduce((a, [k, v]) => {
        const splitKeys = k.split(levelSeparator);
        if (splitKeys.length > 1) {
            const topKey = splitKeys.shift();
            if (topKey) {
                const nextKey = splitKeys.join(levelSeparator);
                const nested = (0, exports.rehydrateFromDottishKeyedObject)({ input: { [nextKey]: v }, levelSeparator });
                if (!(topKey in a)) {
                    a[topKey] = {};
                }
                a[topKey] = deepMerge(a[topKey], nested);
            }
        }
        else {
            a[k] = v;
        }
        return a;
    }, {});
};
exports.rehydrateFromDottishKeyedObject = rehydrateFromDottishKeyedObject;
